module.exports = __webpack_public_path__ + "media/images/games/rocket-league/hiw-2-83f09bc82dc5362b0e917d8117b3d848.jpg";